import _lib from '../_lib';
import active from './active/index';
import {CurrentProvNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'currentprov';
  let activations = [
    {
      name: 'currentprov',
      test: api.messageIs(CurrentProvNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};